import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";

import { REVOKE_PERSONAL_API_KEY } from "./gql";

const useRevokePersonalApiKeyMutation = createDefaultMutationHook(REVOKE_PERSONAL_API_KEY);

const usePersonalApiKeysRevoke = () => {
  const { reportSuccess } = useTypedContext(FlashContext);
  const [revokePersonalApiKey, { loading }] = useRevokePersonalApiKeyMutation();

  const revoke = useCallback(
    async (id: string) => {
      const result = await revokePersonalApiKey({ id }, (data) => {
        if (data) {
          reportSuccess({ message: "API key revoked" });
        }
      });

      return !!result?.data;
    },
    [revokePersonalApiKey, reportSuccess]
  );

  return { revoke, loading };
};

export default usePersonalApiKeysRevoke;
